var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isVoucher
      ? _c(
          "div",
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "收信列表", name: "first" } },
                  [
                    _c(
                      "el-tabs",
                      {
                        on: { "tab-click": _vm.handleReadClick },
                        model: {
                          value: _vm.readName,
                          callback: function($$v) {
                            _vm.readName = $$v
                          },
                          expression: "readName"
                        }
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: { label: "未读", name: "unread" }
                        }),
                        _vm._v(" "),
                        _c("el-tab-pane", {
                          attrs: { label: "已读", name: "read" }
                        }),
                        _vm._v(" "),
                        _c("swb-receiver-msg-list", {
                          attrs: { readFlag: _vm.readFlag }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "发信列表", name: "second" } },
                  [
                    _c("swb-send-msg-list", {
                      attrs: { senderId: _vm.myReceiverId }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isVoucher
      ? _c(
          "div",
          [
            _c("swb-send-msg-list", {
              attrs: {
                isVoucher: _vm.isVoucher,
                group: _vm.group,
                fieldx: _vm.fieldx,
                fieldy: _vm.fieldy,
                receiverData: _vm.receiverData
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5739d9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739d9dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/msg/MsgList.vue
// module id = 2111
// module chunks = 1